import styled from "styled-components";
// import Theme from "../../../../Styles/Themes";
// import config from "../../../../Config/config.json"

import SVG from "react-inlinesvg";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    flex-direction: column;
    width: 80%;
    border-radius: 10px;
    transition: 0.8s;
    padding-top: 15px;
    padding-bottom: 15px;
    &:hover {
        background: #3E78AA;
    }
`;

export const ContainerIcon = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 25px;
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
`;

export const SideBarIcon = styled(SVG)`
    width: 24px;
    height: 24px;
    align-self: center
`;